import {FC, useCallback, useRef, useState} from "react";
import Slider, {Settings} from "react-slick";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {getTeams} from "modules/selectors";
import {MAX_TEAM_COUNT} from "modules/constants";
import {VoteField} from "./VoteField";
import {TeamView, Dots} from "./TeamView";
import {breakpoints} from "assets/theme";
import pageMobileBg from "assets/images/pageMobileBg.png";

const Wrapper = styled.div`
	margin-top: 20px;
	color: ${({theme}) => theme.colorPalette.white};
`;

const Title = styled.div`
	font-family: ${({theme}) => theme.baseFont};
	font-size: 28px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;
	text-align: center;

	@media (min-width: ${breakpoints.tablet}) {
		font-size: 32px;
		text-align: left;
	}
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background: url(${pageMobileBg}) no-repeat center #010101;
	background-size: 100% 100%;
	padding-top: 60px;

	@media (min-width: ${breakpoints.tablet}) {
		padding-top: 48px;
		background: none;
	}
`;

const DotsWrapper = styled.div`
	margin-top: 40px;
	margin-bottom: 46px;

	@media (min-width: ${breakpoints.tablet}) {
		margin-bottom: 38px;
	}
`;

// this component is shown instead of the field when the user has saved 3 commands.
export const UserTeamVotes: FC = () => {
	const teams = useSelector(getTeams);
	const [index, setIndex] = useState(0);
	const {t} = useTranslation();
	const sliderRef = useRef<Slider>(null);

	const settings: Settings = {
		arrows: false,
		dots: false,
		speed: 500,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		beforeChange: (current, next) => setIndex(next),
	};

	const changeHandler = useCallback((index: number) => {
		sliderRef.current?.slickGoTo(index);
	}, []);

	return (
		<Wrapper>
			<Title>
				{t("page.picks.history.vote")} {index + 1} {t("page.picks.history.of")}{" "}
				{MAX_TEAM_COUNT}
			</Title>

			<Container>
				<VoteField>
					<Slider ref={sliderRef} {...settings}>
						{teams.map((team) => (
							<div key={team.id}>
								<TeamView team={team} />
							</div>
						))}
					</Slider>
				</VoteField>

				<DotsWrapper>
					<Dots length={teams.length} index={index} changeHandler={changeHandler} />
				</DotsWrapper>
			</Container>
		</Wrapper>
	);
};
